import { z } from 'zod';

export function isValidUrl(url: string): boolean {
  const result = z.string().url().safeParse(url);
  return result.success;
}

export function addHttpsIfNoScheme(url: string): string {
  // Regular expression to check if the URL already has a scheme (http or https)
  const schemePattern = /^(https?:\/\/)/i;

  // If the URL already has a scheme, return it as is
  if (schemePattern.test(url)) {
    return url;
  }

  // Otherwise, add https:// at the beginning
  return `https://${url}`;
}
